import { useState } from "react";
import CatalogServices from "./../services/CatalogServices";

const useEstados = () => {
    const [catEstados, setCatEstados] = useState([]);
    const [loading, setLoading] = useState(false);

    const getEstado = async () => {
        setLoading(true);
        const services = await CatalogServices.getEstados();
        setLoading(false);
        if (!services.success) return;
        const estadosFormateado = services.data.map((item) => ({ id: item.id_estado, data: item.nombre_estado }));
        setCatEstados(estadosFormateado);
    }

    return { catEstados, getEstado, loading };
};
export default useEstados;